// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchBarIcon[data-v-00f81248]{position:absolute;z-index:999;top:50%;left:5px;transform:translateY(-50%);cursor:auto}.searchBarInput[data-v-00f81248] input[type=text]{padding-left:30px}", ""]);
// Exports
module.exports = exports;
